import { DetailBox } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import GoBackToListButton from '../../../../components/buttons/GoBackToListButton';
import { PathsLayouts } from '../../../../config/routes';
import { TranslationsKeys } from '../../../../locales/translations';
import { useContinuousEducationSectionLoaderData } from '../hooks/ContinuousEducationSectionLoader';

const SectionsEditHeader = () => {
  const data = useContinuousEducationSectionLoaderData();
  const { t } = useTranslation(TranslationsKeys.CONTINUOUS_EDUCATION_SECTIONS);

  return (
    <Row className="mb-4">
      <Col xs={12} sm={6}>
        <GoBackToListButton
          path={`${PathsLayouts.continuousEducation}/sections`}
        />
      </Col>
      <Col xs={12} sm={6}>
        {!!data?.section && (
          <DetailBox
            columns={[
              {
                title: t('detailsBox.section'),
                body: data.section.name,
              },
              {
                title: t('detailsBox.courseCode'),
                body: data.section.course?.code || '',
              },
              {
                title: t('detailsBox.courseName'),
                body: data.section.course?.name || '',
              },
              {
                title: t('detailsBox.campus'),
                body: data.section.campus?.name || '',
              },
              {
                title: t('detailsBox.schedule'),
                body: data.section.schedule?.name || '',
              },
              {
                title: t('detailsBox.maximumStudent'),
                body: String(data.section.maximumStudent ?? 0),
              },
            ]}
          />
        )}
      </Col>
    </Row>
  );
};

export default SectionsEditHeader;
